import { createFileRoute } from '@tanstack/react-router'
import { WeldmapModelPageContent } from 'pages/weldmap/WeldmapModelPage'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'

export const Route = createFileRoute('/weldmap/$kestrelModelId')({
  component: RouteComponent,
  staticData: {
    title: 'Weldmap Model',
    layout: {
      useDynamicViewportHeight: true,
    },
  },
})

function RouteComponent() {
  const { kestrelModelId } = Route.useParams()
  const searchParams = Route.useSearch()

  return (
    <WeldmapModelPageContent
      kestrelModelId={kestrelModelId}
      orgId={searchParams[SEARCH_PARAM_ORG_ID]}
      siteId={searchParams[SEARCH_PARAM_SITE_ID]}
    />
  )
}
